import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: '대시보드',
    link: '/dashboard',
  },
  {
    id: 2,
    label: '회원 관리',
    link: 'userlist',
  },
  {
    id: 3,
    label: '게시물 관리',
    link: 'postlist',
  },
  {
    id: 4,
    label: '광고 관리',
    link: 'ad',
  },
  {
    id: 5,
    label: '신고관리',
    subItems: [
      {
        id: 6,
        label: '게시물 신고 관리',
        link: 'postreport',
        parentId: 5,
      },
      {
        id: 7,
        label: '댓글 신고 관리',
        link: 'commentreport',
        parentId: 5,
      },
      {
        id: 8,
        label: '답변 신고 관리',
        link: 'answerreport',
        parentId: 5,
      },
    ],
  },
  {
    id: 9,
    label: '서비스/정보 관리',
    link: '',
    subItems: [
      {
        id: 10,
        label: '공지사항',
        link: 'notice',
        parentId: 9,
      },
      {
        id: 11,
        label: '이용약관/개인정보',
        link: 'terms',
        parentId: 9,
      },
    ],
  },
];
